import { connect } from "react-redux";
import NavigatorLayout from "./NavigatorLayout";
import { Creators, getCurrentRegistration } from "../../reducer";

export default connect(
  state => ({
    currentRegistration: getCurrentRegistration(state),
    currentRegistrationId: state.registration.currentRegistrationId
  }),
  dispatch => ({
    updateRegistration: (id, data) =>
      dispatch(Creators.updateRegistration(id, data))
  })
)(NavigatorLayout);



// WEBPACK FOOTER //
// ./src/registration/components/Navigator/index.js